import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "preview"]

  connect() {
    this.load()
  }

  change() {
    this.load()
  }

  load() {
    const profileId = this.selectTarget.value
    if (!profileId) {
      this.previewTarget.innerHTML = ""
      return
    }

    fetch(`/admin/invoice_profiles/${profileId}/billing_info`, {
      headers: { "X-Requested-With": "XMLHttpRequest" }
    })
      .then(response => {
        if (response.ok) return response.text()
        throw new Error("Failed to load")
      })
      .then(html => {
        this.previewTarget.innerHTML = html
      })
      .catch(() => {
        this.previewTarget.innerHTML = '<p class="text-sm text-gray-400">Could not load billing info.</p>'
      })
  }
}
